import React from 'react';
import BaseIcon from '@material-ui/icons/AddCircleSharp';

const AddCircleSharp = (props) => <BaseIcon {...props} />;

export default AddCircleSharp;
